// src/components/bsm/CourseComparisonMatrix.js
import React, { useState } from 'react';
import { CheckIcon, CloseIcon, BarChartIcon } from './BsmIcons';

const MATRIX_ROWS = [
  {
    feature: 'Ideal For',
    level1: 'Beginners & salaried employees starting from scratch',
    level2: 'Part-time investors & working professionals wanting swings',
    level3: 'Aspiring full-time intraday traders & scalp specialists',
  },
  {
    feature: 'Course Duration',
    level1: '3 Weeks (15 Live Sessions)',
    level2: '4 Weeks (20 Live Sessions)',
    level3: '6 Weeks (30 Live Sessions)',
  },
  {
    feature: 'Classroom & Online Mode',
    level1: true,
    level2: true,
    level3: true,
  },
  {
    feature: 'Live Market Hours Floor Practice',
    level1: 'Foundational observation drills',
    level2: 'Breakout execution & swing orders',
    level3: 'Daily real-time floor execution (9:15 AM - 3:30 PM)',
  },
  {
    feature: 'Price Action & Candlestick Anatomy',
    level1: true,
    level2: true,
    level3: true,
  },
  {
    feature: 'Multibagger Sector Rotation & Equity Screener',
    level1: false,
    level2: true,
    level3: true,
  },
  {
    feature: 'Mandatory Position Sizing & ≤2% Risk Rule',
    level1: true,
    level2: true,
    level3: true,
  },
  {
    feature: 'Futures & Options (F&O) Derivatives',
    level1: false,
    level2: 'Covered as hedging concept',
    level3: 'Complete mastery (NIFTY / BANK NIFTY)',
  },
  {
    feature: 'Option Greeks (Delta, Theta, Gamma, Vega)',
    level1: false,
    level2: false,
    level3: true,
  },
  {
    feature: 'Live Option Chain Open Interest (OI) Decoding',
    level1: false,
    level2: false,
    level3: true,
  },
  {
    feature: '1-on-1 Mentor Trade Journal Review',
    level1: 'Weekly',
    level2: 'Twice Weekly',
    level3: 'Daily after market close',
  },
  {
    feature: 'Lifetime Trading Desk & Community Access',
    level1: true,
    level2: true,
    level3: true,
  },
  {
    feature: 'Batch Cohort Limit',
    level1: 'Max 15 students per batch',
    level2: 'Max 15 students per batch',
    level3: 'Max 15 students per batch',
  },
];

export default function CourseComparisonMatrix({ onSelectCourse }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="comparison-matrix-wrapper">
      <div className="comparison-matrix-toggle-row">
        <button
          type="button"
          className="btn-toggle-matrix"
          onClick={() => setIsOpen((prev) => !prev)}
          aria-expanded={isOpen}
        >
          <BarChartIcon width={16} height={16} />
          <span>{isOpen ? 'Collapse Comparison Matrix' : 'Compare All 3 Programs Side-by-Side'}</span>
        </button>
      </div>

      {isOpen && (
        <div className="matrix-table-card">
          <div className="matrix-table-responsive">
            <table className="matrix-table">
              <thead>
                <tr>
                  <th className="th-feature">Program Capability</th>
                  <th className="th-course">
                    <span className="th-level-badge">Level 1</span>
                    <strong>Beginner Foundation</strong>
                    <button
                      type="button"
                      className="btn-matrix-enroll"
                      onClick={() => onSelectCourse("Beginner's Stock Market Course")}
                    >
                      Enroll Level 1 →
                    </button>
                  </th>
                  <th className="th-course highlighted">
                    <span className="th-level-badge popular">Level 2 • Most Popular</span>
                    <strong>Swing Master (Equity)</strong>
                    <button
                      type="button"
                      className="btn-matrix-enroll primary"
                      onClick={() => onSelectCourse('Swing Master (Power of Equity)')}
                    >
                      Enroll Level 2 →
                    </button>
                  </th>
                  <th className="th-course">
                    <span className="th-level-badge">Level 3</span>
                    <strong>Master Course (F&amp;O)</strong>
                    <button
                      type="button"
                      className="btn-matrix-enroll"
                      onClick={() => onSelectCourse('Master Course (Full-Time Trader)')}
                    >
                      Enroll Level 3 →
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody>
                {MATRIX_ROWS.map((row, idx) => (
                  <tr key={idx} className={idx % 2 === 0 ? 'row-even' : 'row-odd'}>
                    <td className="td-feature-title">{row.feature}</td>
                    
                    <td className="td-feature-val">
                      {typeof row.level1 === 'boolean' ? (
                        row.level1 ? (
                          <span className="val-check"><CheckIcon width={16} height={16} /></span>
                        ) : (
                          <span className="val-cross"><CloseIcon width={14} height={14} /></span>
                        )
                      ) : (
                        <span>{row.level1}</span>
                      )}
                    </td>

                    <td className="td-feature-val highlighted">
                      {typeof row.level2 === 'boolean' ? (
                        row.level2 ? (
                          <span className="val-check"><CheckIcon width={16} height={16} /></span>
                        ) : (
                          <span className="val-cross"><CloseIcon width={14} height={14} /></span>
                        )
                      ) : (
                        <strong>{row.level2}</strong>
                      )}
                    </td>

                    <td className="td-feature-val">
                      {typeof row.level3 === 'boolean' ? (
                        row.level3 ? (
                          <span className="val-check"><CheckIcon width={16} height={16} /></span>
                        ) : (
                          <span className="val-cross"><CloseIcon width={14} height={14} /></span>
                        )
                      ) : (
                        <span>{row.level3}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
